// extracted by mini-css-extract-plugin
export default {"bankDetailsForm":"bankDetails_bankDetailsForm__HHZWw","bankDetailsBox":"bankDetails_bankDetailsBox__p+sXl"};